import React, { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import "./MyProfile.css";

import PlaceholderProfile from "../../assets/DashboardSidebar/PlaceholderProfilePhoto.png";
import useAuthStore from "../../stores/authStore";

const API_URL = process.env.REACT_APP_API_URL;

const MyProfile = () => {
  const { user, clearUser } = useAuthStore();
  const [quota, setQuota] = useState(null);

  useEffect(() => {
    const fetchQuota = async () => {
      try {
        const res = await fetch(`${API_URL}/api/subscriptions/me/quota`, {
          method: "GET",
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          setQuota(data);
        }
      } catch (err) {
        console.error("Failed to fetch quota:", err);
      }
    };
    fetchQuota();
  }, []);

  if (!user) {
    return (
      <div className="myprofile-loading">
        <p>Loading profile...</p>
      </div>
    );
  }

  const profilePicUrl = user.profile_pic_id || PlaceholderProfile;
  const planName = quota?.plan_name
    ? quota.plan_name.charAt(0).toUpperCase() + quota.plan_name.slice(1)
    : "Free";

  // Logout handler
  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/auth/logout`, {
        method: "GET",
        credentials: "include",
      });
    } catch (err) {
      console.warn("Logout fetch error (ignored):", err);
    } finally {
      clearUser();
      window.location.href = "/";
    }
  };

  return (
    <div className="myprofile-wrapper">
      <div className="myprofile-card-centered">
        {/* Profile photo */}
        <div className="myprofile-photo-centered">
          <img
            src={profilePicUrl}
            alt="Profile"
            className="myprofile-avatar-xl"
          />
        </div>

        {/* Title */}
        <h2 className="myprofile-title">Account Information</h2>

        {/* Personal Info */}
        <div className="myprofile-fields">
          <h3 className="section-title">Personal Info</h3>
          <div className="myprofile-row">
            <label>Name</label>
            <span>{user.name || "—"}</span>
          </div>
          <div className="myprofile-row">
            <label>Email</label>
            <span>{user.email}</span>
          </div>
          {user.linkedin && (
            <div className="myprofile-row">
              <label>LinkedIn</label>
              <a
                href={user.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="myprofile-link"
              >
                View LinkedIn Profile
              </a>
            </div>
          )}

          {/* Subscription */}
          <h3 className="section-title">Subscription</h3>
          <div className="myprofile-plan-card">
            <p className="plan-title">{planName}</p>
            <p className="plan-subtext">Your current subscription</p>
            {quota?.plan_name && quota.plan_name !== "free" && (
              <a href="/dashboard/subscription" className="manage-subscription-link">
                Manage Subscription
              </a>
            )}
          </div>
        </div>

        {/* Logout */}
        <div className="myprofile-logout">
          <button className="btn-logout" onClick={handleLogout}>
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
